import { useEffect, useState } from "react";

const usePageTitle = (options) => {
  const [pageTitle, setPageTitle] = useState();
  // (options?.appTitle || "") && (options?.pageTitle || "") ? ""

  useEffect(() => {
    document.title = pageTitle;
    //eslint-disable-next-line
  }, [pageTitle]);

  useEffect(() => {
    console.log("usePageTitle");
    if (options?.appTitle) {
      if (options?.pageTitle !== "") {
        const titleArray = options.appTitle.split("|");
        setPageTitle(
          titleArray[0] + " | " + options?.pageTitle + " | " + titleArray[1]
        );
        console.log("titleArray", titleArray, pageTitle);
      } else {
        setPageTitle(options.appTitle);
      }
    }
    //eslint-disable-next-line
  }, []);

  return {
    pageTitle,
    setPageTitle,
  };
};

export default usePageTitle;
